export default {
    aboutAppVersion: 'Appversjon {}',
    aboutAppThirdPartyLicenses: 'Tredjepartslisensar',
    aboutAppPrivacy: 'Personvern',

    meAndMyPossessions: 'Meg og mitt',
    myResidency: 'Min bolig',
    aboutApp: 'Om bruk av banken',
    account: 'Konto',
    accountDescription: 'Velg favorittkonto og rekkefølge på kontoer',
    adaptations: 'Tilpasninger',
    contactInfo: 'Kontaktinfo og legitimering',
    language: 'Språk',
    login: 'Innlogging og sikkerhet',
    myConsents: 'Samtykker',
    nextSalary: 'Neste lønn',
    nextSalarySubtitle: 'Se hva du har igjen etter at alle regninger er betalt',
    paymentSettings: 'Betalingsinnstillinger',
    paymentSettingsSubtitle: 'eFaktura, AvtaleGiro og beløpsgrenser',
    aboutPrice: 'Priser',
    menuNew: 'NY',
    aboutThirdPartyLicenses: 'Tredjepartslisensar',
    aboutPrivacy: 'Personvern',
    loginMyActivations: 'Mine enheter',
    aboutVersion: 'Appversjon {}',
    legitimate: 'Legitimer deg',
    chooseLanguage: 'Språkvelger',
    logoutText: 'Logg ut',

    myResidenceLink: '/',
    mittKortLink: '/nettbank/kort',
    allAccountsLink: '/accounts',
    editAccountsLink: '/accounts/edit',
    agrees: '/samtykker',
    nettpostLink: '/profile/nettpost',
    messagesLink: '/profile/sikker-kommunikasjon',
    logoutLink: '/loggut',
    paymentPageLink: '/payment',
    stoppedPaymentsLink: '/stopped-payments',
    futurePaymentsListLink: '/futurepaymentslist',
    ahvSigningLink: '/esignering',
    priceListLink: '/',
    privacyLink: '/settings/privacy',
    thirdPartyDependenciesLink: '/settings/about-app/third-party-dependencies',
    myActivationsLink: '/settings/activations',
    editSalaryInfoStartPageLink: '/edit-salary-info-start-page',
    loginSettingsLink: '/settings/login',
    paymentSettingsLink: '/settings/payment',
    myConsentsLink: '/settings/consent',
    legitimateLink: '/innstillinger/Legitimer-deg',
    changeLanguageLink: '/innstillinger/change-language',
    changeLanguagePageLink: '/profile/language',

    enableNextSalary: 'true',
    enableLanguageSelection: 'false',

    loginChangeCustomerRelations: 'Bytt kundeforhold',
    loginUpdateError: 'Klarte ikke å oppdatere',
    biometricLoginText: 'Innlogging med',
};
